import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import { onMounted, ref } from "vue";
import { ColumnModel } from "@syncfusion/ej2-grids/src/grid/models/column";
import { DateColumn, DateTimeColumn, DefaultColumn } from "@/shared/ui/types/SogGridColumnDefinitions";
import SogGrid from "@/shared/ui/SogGrid.vue";
import { RowSelectEventArgs } from "@syncfusion/ej2-vue-grids";
import DtoSearch from "@/shared/model/DtoSearch";
import VehicleRegistrationInfo from "@/modules/VehicleRegistration/components/VehicleRegistrationInfo.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import { Api } from "@/shared/services/api";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPage',
  setup(__props) {

const eNumber = ref<InstanceType<typeof SogTextBox>  | null>(null)
const _number = ref("");
const _kennzeichen = ref("");
const _fahrzeugIdentifizierungsnummer = ref("");

const _grid = ref<InstanceType<typeof SogGrid>  | null>(null)

const _url = Api.baseUrl+'/Search';

const _columns: ColumnModel[] = [
  /*
  { type: 'checkbox' },
*/
  { ...DefaultColumn, field: 'insuranceId', headerText: 'Insurance Id', isPrimaryKey: true ,visible:false},
  { ...DefaultColumn, field: 'vehicleRegistrationId', headerText: 'VehicleRegistrationId',visible:false},
  { ...DefaultColumn, field: 'insuranceNumber', headerText: 'Versicherungsnummer', filter: { type: 'CheckBox' } },
  { ...DefaultColumn, field: 'evb', headerText: 'eVb' },
  { ...DefaultColumn, field: 'kennzeichen', headerText: 'Kennzeichen' },
  { ...DateTimeColumn, field: 'datumVersicherungsBeginn', headerText: 'Versicherungsbeginn' },
  { ...DateColumn, field: 'kennzeichenDatumGueltigBis', headerText: 'Versicherungsende' },
  { ...DefaultColumn, field: 'fahrzeugIdentifizierungsNummer', headerText: 'FahrzeugIdentifizierungsnummer' },

]


onMounted(()=>{
  eNumber.value?.focus()
})

function onSearch(){
  _grid.value?.adaptor.removePredicate("number");
  if(_number.value)
    _grid.value?.adaptor.addPredicate("number","contains",_number.value.toUpperCase());

  _grid.value?.adaptor.removePredicate("kennzeichen");
  if(_kennzeichen.value)
    _grid.value?.adaptor.addPredicate("kennzeichen","contains",_kennzeichen.value.toUpperCase());

  _grid.value?.adaptor.removePredicate("fahrzeugIdentifizierungsNummer");
  if(_fahrzeugIdentifizierungsnummer.value)
    _grid.value?.adaptor.addPredicate("fahrzeugIdentifizierungsNummer","contains",_fahrzeugIdentifizierungsnummer.value.toUpperCase());

  _grid.value?.refresh();
}

const data = ref<DtoSearch>();

function onRowSelected(args:any){
  const a = args as RowSelectEventArgs;
  data.value = a.data as DtoSearch;
}

function onRowDeselected(args:any){
  if(!args.isInteracted)
    return
  data.value = undefined;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: "Recherche" }, {
    default: _withCtx(() => [
      _createVNode(SogFlexRow, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(SogCard, null, {
              default: _withCtx(() => [
                _createVNode(SogCardTitle, null, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("Suchkriterien", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(SogCardContent, null, {
                  default: _withCtx(() => [
                    _createVNode(SogForm, null, {
                      default: _withCtx(() => [
                        _createVNode(SogFormField, null, {
                          default: _withCtx(() => [
                            _createVNode(SogTextBox, {
                              ref_key: "eNumber",
                              ref: eNumber,
                              modelValue: _number.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_number).value = $event)),
                              placeholder: "Versicherungsnummer",
                              "interval-modified": onSearch
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(SogFormField, null, {
                          default: _withCtx(() => [
                            _createVNode(SogTextBox, {
                              modelValue: _kennzeichen.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_kennzeichen).value = $event)),
                              placeholder: "Kennzeichen",
                              "interval-modified": onSearch
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(SogFormField, null, {
                          default: _withCtx(() => [
                            _createVNode(SogTextBox, {
                              modelValue: _fahrzeugIdentifizierungsnummer.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_fahrzeugIdentifizierungsnummer).value = $event)),
                              placeholder: "FahrzeugIdentifizierungsnummer",
                              "interval-modified": onSearch
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(SogCardActions, null, {
                  default: _withCtx(() => [
                    _createVNode(SogCardActionButton, {
                      ref: "btnSearch",
                      "mdi-icon": "mdi-magnify",
                      onClick: onSearch
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" Suchen ", -1)
                      ]))]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createVNode(VehicleRegistrationInfo, { data: data.value }, null, 8, ["data"]), [
            [_vShow, data.value]
          ])
        ]),
        _: 1
      }),
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Ergebnis", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogGrid, {
                ref_key: "_grid",
                ref: _grid,
                url: _url,
                columns: _columns,
                "on-row-selected": onRowSelected,
                "on-row-deselected": onRowDeselected
              }, null, 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})